import { api } from '../../config/ApiConfig';

export const Preferences = {
  load: (withAddress, page) => api.get(`/v1/users?${
    withAddress && 'included=musical_preferences,city,city.state&'}page[number]=${page}&page[size]=10`),
}